/**
 *	List of action names and status values
 * to be used in url's and color coding
 *
 * @export
 * @returns {Array}
 */
export default () => [
	{
		name: 'Patients',
		status: 'all',
		color: '#d270ac'
	},
	{
		name: 'Opened',
		status: 'opened',
		color: '#97cb6e'
	},
	{
		name: 'Got It',
		status: 'gotit',
		color: '#44b7ad'
	},
	{
		name: 'Learn More',
		status: 'learnmore',
		color: '#7e80e8'
	},
	{
		name: 'No Action',
		status: 'noaction',
		color: '#f57b85'
	}
]
